import type { FooterCell, NavItem } from '@/types'

export const navItems: NavItem[] = [
    { label: 'Pixels°', href: '/' },
    { label: 'Sections', href: '/#pixels' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' }
]

export const footerCells: FooterCell[] = [
    { label: 'Subscription library', href: '/about' },
    { label: 'Premium web sections', href: '/contact' },
    { label: 'Est. 2026' }
]
